'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002429 from "./presto.-Groups-View$$anon$29.js";
import * as $j_presto$002etypes$0024$002dRole$0024 from "./presto.types$-Role$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dId$0024 from "./presto.types$-Role-Id$.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024 from "./presto.types$-Role-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$28() {
  this.aXI = null;
  this.aXA = null;
  this.aXB = false;
  this.aXJ = null;
  this.aXK = false;
  this.aXN = null;
  this.aXG = null;
  this.aXH = false;
  this.aXC = null;
  this.aXD = false;
  this.aXE = null;
  this.aXF = false;
  this.aXL = false;
  this.aXM = false;
  this.aXI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aXN = "Role";
}
export { $c_Lpresto_GroupsView$$anon$28 as $c_Lpresto_GroupsView$$anon$28 };
$p = $c_Lpresto_GroupsView$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$28;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$28() {
}
export { $h_Lpresto_GroupsView$$anon$28 as $h_Lpresto_GroupsView$$anon$28 };
$h_Lpresto_GroupsView$$anon$28.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aXI;
});
$p.L = (function() {
  if ((!this.aXB)) {
    this.aXA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aXB = true;
  }
  return this.aXA;
});
$p.O = (function() {
  if ((!this.aXK)) {
    this.aXJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aXK = true;
  }
  return this.aXJ;
});
$p.E = (function() {
  return this.aXN;
});
$p.t = (function() {
  if ((!this.aXH)) {
    this.aXG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aXH = true;
  }
  return this.aXG;
});
$p.M = (function() {
  if ((!this.aXD)) {
    this.aXC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dId$0024.$m_Lpresto_types$RoleId$().nM(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kw(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dName$0024.$m_Lpresto_types$RoleName$().nN(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aXD = true;
  }
  return this.aXC;
});
$p.Q = (function() {
  if ((!this.aXF)) {
    this.aXE = new $j_presto$002e$002dGroups$002dView$0024$0024anon$002429.$c_Lpresto_GroupsView$$anon$29();
    this.aXF = true;
  }
  return this.aXE;
});
$p.w = (function() {
  if ((!this.aXM)) {
    this.aXL = false;
    this.aXM = true;
  }
  return this.aXL;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee283) => ((p) => \u03b4scrutinee283.nH(p)))($j_presto$002etypes$0024$002dRole$0024.$m_Lpresto_types$Role$())));
});
var $d_Lpresto_GroupsView$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$28, "presto.GroupsView$$anon$28", ({
  JI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$28 as $d_Lpresto_GroupsView$$anon$28 };
//# sourceMappingURL=presto.-Groups-View$$anon$28.js.map
